// src/App.jsx
import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import AOS from 'aos';

import Header from './components/header/Header';
import NXTLVLLoader from './components/loader/NXTLVLLoader';
import Landing from './components/landing/Landing';
import routes from './pages';
import Page404 from './pages/404';
import SocialProofToasts from './components/FOMO/SocialProofToasts';

import './components/landing/landing.css';
import data from './components/FOMO/socialProofData';
import logo from './assets/images/logo/logo.svg';export default function App() {
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [showLanding, setShowLanding] = useState(location.pathname === '/');

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 900);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    setShowLanding(location.pathname === '/');
  }, [location.pathname]);

  useEffect(() => {
    if (!loading && !showLanding) {
      AOS.init({ duration: 900, once: true });
    }
  }, [loading, showLanding]);

  const handleEnter = () => setShowLanding(false);

  if (loading) return <NXTLVLLoader />; // (see Option B below if you want toasts during loader too)

  return (
    <>
      {showLanding ? (
        <Landing onEnter={handleEnter} />
      ) : (
        <>
          <Header />
          <Routes>
            {routes.map((r, i) => (
              <Route key={i} path={r.path} element={r.component} />
            ))}
            <Route path="/rsvp" element={<Navigate to="/contact" replace />} />
            <Route path="*" element={<Page404 />} />
          </Routes>
        </>
      )}

      {/* Show FOMO everywhere (landing + all pages) */}
{/*       <SocialProofToasts
        position="top-right"
        intervalMs={[28000, 42000]} // random range for natural cadence
        jitterPct={0.15} // only used if intervalMs is a single number
        firstDelayRange={[6000, 12000]} // first toast after 8–15s
        toastDuration={9000} // ~9s visible
        maxShowsPerSession={6}
        quietAfterCloseMs={120000} // 2 min quiet after ×
        quietHours={[2, 6]} // e.g. [1, 6] to mute 1am–6am (24h clock, local time)
        respectReducedMotion={true} // honors OS “reduce motion” setting
        theme="auto"
        accent="#5c27fe"
        dataset={data}
        logoUrl="/demo/posh.svg" // direct path from public/
      /> */}
    </>
  );
}
